export type CoachCitation = { type?: string; id?: string; author?: string };

export type CoachMessage = {
  role: "user" | "coach";
  text: string;
  skillUsed?: string | null;
  citations?: CoachCitation[];
  concepts?: Record<string, string[]>;
  error?: string;
};

const COACH_KEY = "gto-coach-history-v1";
const EVENT = "gto-coach-history";

export const EMPTY_COACH_HISTORY: CoachMessage[] = [];

let cache: CoachMessage[] = EMPTY_COACH_HISTORY;
let cacheRaw: string | null = null;

function readRaw(): string | null {
  try {
    return localStorage.getItem(COACH_KEY);
  } catch {
    return null;
  }
}

// 缓存快照（按 raw 字符串记忆化，保证 useSyncExternalStore 引用稳定）
export function getCoachHistorySnapshot(): CoachMessage[] {
  const raw = readRaw();
  if (raw !== cacheRaw) {
    cacheRaw = raw;
    if (!raw) {
      cache = EMPTY_COACH_HISTORY;
    } else {
      try {
        const parsed = JSON.parse(raw) as CoachMessage[];
        cache = Array.isArray(parsed) ? parsed : EMPTY_COACH_HISTORY;
      } catch {
        cache = EMPTY_COACH_HISTORY;
      }
    }
  }
  return cache;
}

export function subscribeCoachHistory(onChange: () => void): () => void {
  window.addEventListener("storage", onChange);
  window.addEventListener(EVENT, onChange);
  return () => {
    window.removeEventListener("storage", onChange);
    window.removeEventListener(EVENT, onChange);
  };
}

function write(messages: CoachMessage[]): void {
  try {
    localStorage.setItem(COACH_KEY, JSON.stringify(messages));
    window.dispatchEvent(new Event(EVENT));
  } catch {
    /* private mode / quota */
  }
}

export function appendCoachHistory(msg: CoachMessage): void {
  write([...getCoachHistorySnapshot(), msg]);
}

export function clearCoachHistory(): void {
  write([]);
}
